import { put } from 'redux-saga/effects';
import { extractErrorFromResponse } from '../../assets/js/function-utils';
import BEM_FIELDS from '../../consts/bem-fields';
import COMBO_FIELDS from '../../consts/combo-fields';
import DADOS_SIM from '../../consts/consts';
import ENDPOINTS from '../../consts/endpoints';
import MOTOR_FIELDS from '../../consts/motor';
import { unmaskMoney } from '../../normalizers/normalize';
import api from '../../services/api';
import SessionService from '../../session/session-service';
import { Creators as CombosAction } from '../ducks/combos';
import { FROM_HISTORICO_KEY } from '../../consts/system-const';

const dadosCliente = DADOS_SIM.DADOS_CLIENTE;
const dadosCotacaoFields = DADOS_SIM.DADOS_COTACAO;
const listaBensFields = DADOS_SIM.LISTA_BENS;
const personalizadoFields = DADOS_SIM.PERSONALIZADO;
const motorFields = MOTOR_FIELDS;
const comboMotorFields = COMBO_FIELDS.MOTOR;
const motorFieldsEntrada = MOTOR_FIELDS.ENTRADA;
const motorFieldsSaida = MOTOR_FIELDS.SAIDA;
const conteudoFields = DADOS_SIM.CONTEUDO;
const bemFields = BEM_FIELDS;

const ERROR_MSG = 'Houve um erro ao processar a requisição. Por favor tente novamente.';

export function* calcularCotacao(action) {
    try {
        const { dadosCotacao, comissao, comLog, todosCombos } = action.payload;
        const { percentualAgravo, percentualDesconto } = dadosCotacao;

        const bens = adjustBensToSend(dadosCotacao[listaBensFields.THIS]);

        const motorEntrada = {
            [personalizadoFields.CALCULAR_PERSONALIZADO]: dadosCotacao[personalizadoFields.CALCULAR_PERSONALIZADO],
            [dadosCliente.CODIGO_COTACAO]: dadosCotacao[dadosCliente.CODIGO_COTACAO],
            [motorFieldsEntrada.BENS]: bens,
            [motorFieldsEntrada.COMISSAO_TOTAL_OPERACAO]: comissao ? Math.round(comissao * 100) : null,
            [dadosCotacaoFields.PERC_DESCONTO]: percentualDesconto,
            [dadosCotacaoFields.PERC_AGRAVO]: percentualAgravo
        };

        const { data } = yield api.post(ENDPOINTS.CALCULAR_COTACAO(comLog, todosCombos), motorEntrada);

        if (data && data.resultado) {
            let resultadoCalculo = data.resultado;

            resultadoCalculo = checkIfHasPersonalizadoAndAdjustId(resultadoCalculo);
            /** Salva na Session */
            SessionService.saveSession({
                [motorFields.RESULTADO_CALCULO]: resultadoCalculo,
                [FROM_HISTORICO_KEY]: false
            });
            yield put(CombosAction.calcularCotacaoSuccess(resultadoCalculo));
        } else {
            yield put(CombosAction.calcularCotacaoFailure(ERROR_MSG));
        }
    } catch (err) {
        yield put(CombosAction.calcularCotacaoFailure(extractErrorFromResponse(err)));
    }
}

export function* salvarCotacao(action) {
    try {
        const { idCombo, codigoCotacao, parcelaEmGarantia, parcelaEmNaoGarantia } = action.payload;

        const response = yield api.patch(ENDPOINTS.SALVAR_RESULTADO_CALCULO(codigoCotacao), null, {
            params: { idCombo, parcelaEmGarantia, parcelaEmNaoGarantia }
        });
        if (response.data.resultado) {
            const resultado = response.data.resultado;
            const statusCotacao = resultado[dadosCotacaoFields.STATUS_COTACAO];
            SessionService.saveSession({ [dadosCotacaoFields.STATUS_COTACAO]: statusCotacao });
            yield put(CombosAction.salvarCotacaoSuccess());
        } else {
            throw new Error();
        }
    } catch (err) {
        yield put(CombosAction.salvarCotacaoFailure(extractErrorFromResponse(err)));
    }
}

function adjustBensToSend(bens) {
    const bensAjustados =
        bens &&
        bens.map((bem) => {
            if (bem) {
                return {
                    [bemFields.ID]: bem[listaBensFields.ID],
                    [bemFields.ID_BEM]: bem[listaBensFields.ID_BEM],
                    [bemFields.NOME]: bem[listaBensFields.NOME_BEM],
                    [bemFields.ID_TIPO_BEM]: bem[listaBensFields.ID_TIPO_BEM],
                    [bemFields.NOME_TIPO_BEM]: bem[listaBensFields.TIPO_BEM],
                    [bemFields.QUANTIDADE]:
                        bem[listaBensFields.QUANTIDADE] && parseFloat(bem[listaBensFields.QUANTIDADE]),
                    [bemFields.VALOR_UNITARIO]: parseFloat(
                        unmaskMoney(bem[listaBensFields.VALOR_UNITARIO_BEM].toString())
                    ),
                    [bemFields.CONTEUDOS]: adjustConteudosToSend(bem[listaBensFields.COTACAO_CONTEUDO]),
                    [bemFields.QUESTIONARIOS]: bem[listaBensFields.QUESTIONARIO_RESPOSTAS],
                    [bemFields.IN_GARANTIA]: bem[listaBensFields.GARANTIA],
                    [bemFields.ID_TIPO_CONSTRUCAO]: bem[listaBensFields.ID_TIPO_CONSTRUCAO],
                    [bemFields.COBERTURAS_PERSONALIZADO]: bem[listaBensFields.COBERTURAS_PERSONALIZADO],
                    [bemFields.PERC_AGRAVO]: bem[listaBensFields.AGRAVO],
                    [bemFields.PERC_DESCONTO]: bem[listaBensFields.DESCONTO]
                };
            } else {
                return bem;
            }
        });
    return bensAjustados;
}

function adjustConteudosToSend(conteudos) {
    const conteudosAjustados =
        conteudos &&
        conteudos.map((conteudo) => {
            if (conteudo) {
                return {
                    ...conteudo,
                    [conteudoFields.QUANTIDADE]: parseFloat(conteudo[conteudoFields.QUANTIDADE]),
                    [conteudoFields.VALOR_TOTAL]: parseFloat(
                        unmaskMoney(conteudo[conteudoFields.VALOR_TOTAL].toString())
                    ),
                    [conteudoFields.VALOR_UNITARIO_CONTEUDO]: parseFloat(
                        unmaskMoney(conteudo[conteudoFields.VALOR_UNITARIO_CONTEUDO].toString())
                    )
                };
            } else {
                return conteudo;
            }
        });
    return conteudosAjustados;
}

function checkIfHasPersonalizadoAndAdjustId(resultadoCalculo) {
    const listaCombos = resultadoCalculo[motorFieldsSaida.LISTA_COMBOS];
    const comboPersonalizado = listaCombos.find((combo) => combo[comboMotorFields.PERSONALIZADO]);
    if (Boolean(comboPersonalizado)) {
        comboPersonalizado[comboMotorFields.FRONT_ID] = 'P_' + parseInt(Math.random() * 100);
    }
    return resultadoCalculo;
}
